/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { HelloControllerBreakWorkersMutationResponse } from "../types/HelloControllerBreakWorkers.ts"

export const helloControllerBreakWorkersMutationKey = () =>
  [{ url: "/break-workers" }] as const

export type HelloControllerBreakWorkersMutationKey = ReturnType<
  typeof helloControllerBreakWorkersMutationKey
>

/**
 * {@link /break-workers}
 */
export async function helloControllerBreakWorkers(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    HelloControllerBreakWorkersMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "POST", url: `/break-workers`, ...requestConfig })
  return res
}

export function helloControllerBreakWorkersMutationOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const mutationKey = helloControllerBreakWorkersMutationKey()
  return mutationOptions<
    ResponseConfig<HelloControllerBreakWorkersMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async () => {
      return helloControllerBreakWorkers(config)
    },
  })
}

/**
 * {@link /break-workers}
 */
export function useHelloControllerBreakWorkers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<HelloControllerBreakWorkersMutationResponse>,
      ResponseErrorConfig<Error>,
      void,
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? helloControllerBreakWorkersMutationKey()

  const baseOptions = helloControllerBreakWorkersMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<HelloControllerBreakWorkersMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >

  return useMutation<
    ResponseConfig<HelloControllerBreakWorkersMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<HelloControllerBreakWorkersMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >
}
